import {authentication} from '../models/Authentication';
import {DOMAIN} from '../constants/URLs'; // import DOMAIN instead on server-change

export class reportAPI {
  static user(reportedID, reporterID) {
    return authentication.getAccessToken().then((accessToken) => {
      return fetch(`${DOMAIN}api/report/user/${reportedID}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: reporterID,
      })
        .then((response) => {
          if (response.ok) return response.json();
          else throw new Error('Error reporting user');
        })
        .catch((err) => {
          console.warn(err);
          throw new Error('Error reporting user');
        });
    });
  }

  static userPost = (reportedID, reportedStreamID, reporterUserID) => {
    return authentication.getAccessToken().then((accessToken) => {
      const url = `${DOMAIN}api/report/user/${reportedID}/post/${reportedStreamID}`;
      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: reporterUserID,
      }).then((result) => {
        if (result.ok) return;
        else throw new Error('Error reporting user post');
      });
    });
  };

  static event = (eventID, reporterUserID) => {
    return authentication.getAccessToken().then((accessToken) => {
      const url = `${DOMAIN}api/report/event/${eventID}`;
      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: reporterUserID,
      }).then((result) => {
        if (result.ok) return;
        else throw new Error('Error reporting the event');
      });
    });
  };

  static eventPost = (eventID, streamID, reporterUserID) => {
    return authentication.getAccessToken().then((accessToken) => {
      const url = `${DOMAIN}api/report/event/${eventID}/post/${streamID}`;
      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: reporterUserID,
      }).then((result) => {
        if (result.ok) return;
        else throw new Error('Error reporting the event post');
      });
    });
  };

  static userComment = (reportedID, reactionID, reporterUserID) => {
    return authentication.getAccessToken().then((accessToken) => {
      const url = `${DOMAIN}api/report/user/${reportedID}/reaction/${reactionID}`;
      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: reporterUserID,
      }).then((result) => {
        if (result.ok) return;
        else throw new Error('Error reporting the comment');
      });
    });
  };

  // currently unused
  static group = (groupID, reporterUserID) => {
    return authentication.getAccessToken().then((accessToken) => {
      const url = `${DOMAIN}api/report/group/${groupID}`;
      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: reporterUserID,
      }).then((result) => {
        if (result.ok) return;
        else throw new Error('Error reporting the group');
      });
    });
  };

  static groupPost = (groupID, streamID, reporterUserID) => {
    return authentication.getAccessToken().then((accessToken) => {
      const url = `${DOMAIN}api/report/group/${groupID}/post/${streamID}`;
      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: reporterUserID,
      }).then((result) => {
        if (result.ok) return;
        else throw new Error('Error reporting the group');
      });
    });
  };
}
